module.exports = __webpack_public_path__ + "static/media/coingecko.e071ee42.svg";